import { createFileRoute } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { Login as LoginForm } from '../components/Login';
import { getAuthStore } from '../main';

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
  },
  component: Login,
});

function Login() {
  return (
    <div style={{ gridArea: 'main / sidebar / main / main' }}>
      <Pane classes={'sp-loginAdmin'} tag="main">
        <LoginForm />
      </Pane>
    </div>
  );
}
